<template>
  <div>
    <v-col cols="12" sm="2">
      <v-form
          v-for="(dimension, i) in this.dimensions"
          :key="i"
          lazy-validation
      >
        <v-text-field
            type="text"
            min="0"
            v-model="dimension.price"
            v-bind:label="dimension.categoryName + ': ' + dimension.name"
        ></v-text-field>
      </v-form>
    </v-col>
    <div>
      <v-btn
          @click="save()"
      >
        Zapisz&nbsp;
        <v-icon size="24" right>
          mdi-content-save-outline
        </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";

export default {
  props: {
    branchId: {
      type: [String],
      required: true,
    }
  },
  components: {},
  data() {
    return {
      loading: false,
      isDirty: false,
      loggingEnabled: false,
      options: {},
      dimensions: [],
    };
  },
  created() {

  },
  mounted() {
    this.load();
  },
  methods: {
    load(options = {}) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      options = options || {};

      api.get(`/api/price-list/company-branch/${this.branchId}`)
          .then((response) => {
            this.dimensions = response.data.dimensions;
            if (options.onSuccess) {
              options.onSuccess();
            }
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się wczytać wymiarów.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    refresh() {
      this.load();
    },
    save: function () {
      this.loading = true;

      this.dimensions.forEach(dimension => {
        dimension.price = dimension.price !== '' ? dimension.price : null;
      });

      api.put(`/api/price-list/company-branch/${this.branchId}/dimension`, {
        'dimensions': this.dimensions
      })
          .then(() => {
              this.$root.$emit('notifySuccess', {
                html: 'Wymiary zostały zapisane.',
                callback: () => {
                  setTimeout(function () {
                    self.saving = false;
                  }, 500);
                }
              });
            this.refresh();
            })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się zapisać wymiarów.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
}
</script>